import React from "react";
import styles from "./ToggleButtonsEditSections.module.scss";
import { SectionWidth } from "../../../../shared";

type OwnProps = {
    sectionSizes: SectionWidth[] | number[];
    activeWidth: SectionWidth;
    setActiveWidth: (width: SectionWidth) => void;
};

const ToggleButtonsEditSections: React.FunctionComponent<OwnProps> = ({
    sectionSizes,
    setActiveWidth,
    activeWidth,
}) => {
    return (
        <div className={styles.container}>
            {sectionSizes.map((size, index) => {
                return (
                    <React.Fragment key={size}>
                        <div
                            onClick={() => setActiveWidth(size)}
                            className={[styles.btn, size === activeWidth ? styles.active : styles.inactive].join(" ")}
                        >
                            {size}
                        </div>
                    </React.Fragment>
                );
            })}
        </div>
    );
};

export default ToggleButtonsEditSections;
